module.exports = __webpack_public_path__ + "img/c3.ebececc4.png";